import { Company } from '@/class/model/mdm/Company'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { User } from '@/class/model/sys/User'
import { cache, cacheName } from '@/utils/cacheManager'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { SC_CARGO_SOURCE } from '@/class/cargo/model/parameters/CargoSource'

export class OverseaCustomerUtils {
  static async getOverseaAgentUserByConfig() {
    await cache.load(cacheName.CONFIG)
    const isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    if (isHC) {
      return
    }
    const overseaAgentUsersConfig = parseInt(cache.config.get('overseaAgentUsersConfig'))
    if (overseaAgentUsersConfig === 1) {
      return await User.getUsersByPrivilegeDetail('role', 'overseaOp', '', null, true)
    }
    return []
  }
  /**
   * 判断海外客服是否有效
   */
  static isActiveOverSeaOp(view) {
    let flag = false
    const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
    if (view.job && view.job.overseaOp) {
      const user = userList.find(p => p.userId === view.job.overseaOp)
      if (user && user.active) {
        flag = true
      }
    }
    return flag
  }
  /**
   * 加载海外客服
   */
  // private var _cmpId: int = 0
  static async loadOverseaAgentChanged(view, setDefaultValueFlag = false) {
    await cache.load(cacheName.CONFIG)
    const isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    if (isHC) {
      return
    }
    const job = view.job
    view.overseaAgentUsersList = []
    let cmpIdx = 0
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      cmpIdx = job.designationAgent // 根据指定货确定海外客服
    } else {
      if (job.lob === 'AI') {
        cmpIdx = job.loadingAgentId // 空进根据起运港确定海外客服
      } else {
        cmpIdx = job.destinationAgent // 还是根据目的港代理确定海外客服
      }
    }
    const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
    const companyList = getCacheListByKey(basicCacheKeys.basic_data_Company)
    const cmp = companyList.find(p => p.cmpIdx === cmpIdx)
    let overseaAgentUserDefaultId = 0
    if (cmp) {
      const agent = await new Company(cmp).getOverseaAgentDetail()
      if (agent) {
        const overseaAgentUsers = await new OverseaAgent(agent).getOverseaAgentUserList()
        // 海外客服
        const overseaAgentUsersList = []
        if (overseaAgentUsers && overseaAgentUsers.length > 0) {
          for (const u of overseaAgentUsers) {
            if (u.lob === job.lob || !u.lob || u.lob === 'ALL') {
              const user = userList.find(p => p.userId === u.userId)
              if (user && user.active) {
                if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                  if (u.defaultUser) {
                    overseaAgentUserDefaultId = u.userId
                  }
                  overseaAgentUsersList.push(user)
                }
              }
            }
          }
        }
        // 海外客服
        view.overseaAgentUsersList = overseaAgentUsersList
      }
    }
    // 设置默认值
    if (view.overseaAgentUsersList && view.overseaAgentUsersList.length > 0) {
      if ((setDefaultValueFlag || view.action === 'copy')) {
        let overseaOp = 0
        if (overseaAgentUserDefaultId > 0) {
          overseaOp = overseaAgentUserDefaultId
        } else {
          overseaOp = view.overseaAgentUsersList[0].userId
        }

        let newUser = null
        if (overseaOp > 0) {
          newUser = userList.find(p => p.userId === overseaOp)
        }

        if (newUser && overseaOp !== job.overseaOp) {
          // 复制时判断
          if (view.action === 'copy') {
            const overseaUser = userList.find(p => p.userId === job.overseaOp)
            const oldOverseaUser = !overseaUser ? '' : !overseaUser.chineseName ? overseaUser.englishName : overseaUser.chineseName// 原业务 海外客服
            const newOverseaUser = !newUser ? '' : !newUser.chineseName ? newUser.englishName : newUser.chineseName// 新 海外客服
            if (overseaUser && this.isActiveOverSeaOp(view) && view.overseaAgentUsersList.find(p => p.userId === overseaUser.userId)) {
              overseaOp = job.overseaOp
            } else {
              let msg = view.$t('SeaExport.OverseaCustomerUpdate')
              msg = msg.replace('{0}', oldOverseaUser)
              msg = msg.replace('{1}', newOverseaUser)
              view.$confirm(msg, view.$t('Message.Prompt'), {
                confirmButtonText: view.$t('common.btn.ok'),
                cancelButtonText: view.$t('common.btn.cancel'),
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                job.overseaOp = overseaOp
                this.overseaOpChangeHandler(view)
              }).catch(() => {
                job.overseaOp = 0
                job.overseaOpDepartment = 0
              }).finally(() => {
              })
            }
          } else {
            job.overseaOp = overseaOp
            await this.overseaOpChangeHandler(view)
          }
        }
      }
    } else {
      view.overseaAgentUsersList = await this.getOverseaAgentUserByConfig()
      if (setDefaultValueFlag) {
        job.overseaOp = 0
        job.overseaOpDepartment = 0
      } else if (view.action === 'copy') {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          if (!job.designationAgent) {
            job.overseaOp = 0
            job.overseaOpDepartment = 0
          }
        } else {
          if (job.lob === 'AI') { // 空进根据起运港确定海外客服
            if (!job.loadingAgentId) {
              job.overseaOp = 0
              job.overseaOpDepartment = 0
            }
          } else { // 还是根据目的港代理确定海外客服
            if (!job.destinationAgent) {
              job.overseaOp = 0
              job.overseaOpDepartment = 0
            }
          }
        }
        if (job.overseaOp !== 0) {
          const overseaUser = userList.find(p => p.userId === job.overseaOp)
          if (!(overseaUser && this.isActiveOverSeaOp(view) && view.overseaAgentUsersList.find(p => p.userId === overseaUser.userId))) {
            job.overseaOp = 0
            job.overseaOpDepartment = 0
          }
        }
      }
    }
  }

  /**
   * 海外客服切换
   * @param job
   * @param view
   * @param data
   * @returns {Promise<void>}
   */
  static async overseaOpChangeHandler(view, data) {
    const job = view.job
    if (!data) {
      const userList = getCacheListByKey(basicCacheKeys.basic_data_User)
      data = userList.find(p => p.userId === job.overseaOp)
    }
    job.overseaOpDepartment = 0
    if (data) {
      if (!cache.office) {
        cache.load(cacheName.OFFICE)
      }
      const offices = await User.getUserDepartmentOffices('role', 'overseaOp', job.overseaOp)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === cache.office.officeId) {
            job.overseaOpDepartment = item.departmentId
            break
          }
        }
      } else {
        const dep = await new User(data).getDefaultDepartment('role', 'overseaOp')
        job.overseaOpDepartment = dep ? dep.departmentId : 0
      }
    }
  }

  /**
   * 【目的港代理】切换
   * @param job
   * @param view
   * @returns {Promise<void>}
   */
  static async destinationAgentChangeHandler(view) {
    if (view.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
      await this.loadOverseaAgentChanged(view, true)
    }
  }

  /**
   * 【指定货代理】【揽货类型】切换
   * @param job
   * @param view
   * @returns {Promise<void>}
   */
  static async designationAgentOrCargoSourceChangeHandler(view) {
    await this.loadOverseaAgentChanged(view, true)
  }
}
